import React from "react";
import { useNavigate } from "react-router-dom";
import Datatable from "./common/datatable";
import ActionMenu from "./common/menu";
import { getRowIsActive } from "../utils/parseIsActive";
import FallbackImage from "./common/fallbackImage";

const IndustryData = ({ data, onEdit, onView, onDelete }) => {
  const navigate = useNavigate();

  const handleView = (industry) => {
    const id = industry._id || industry.id;
    if (onView) {
      onView(industry);
    } else {
      navigate(`/industries/view/${id}`);
    }
  };

  // Columns
  const columns = [
    {
      key: "image",
      label: "Image",
      render: (value) =>
        value ? (
          <FallbackImage
            src={value}
            alt="img"
            style={{ width: 35, height: 35, borderRadius: "4px", objectFit: "cover" }}
          />
        ) : null,
    },
    { key: "title", label: "Title" },
    { key: "description", label: "Description" },
    {
      key: "country",
      label: "Country",
      render: (v, row) => row.country || row.location || "-",
    },
    {
      key: "status",
      label: "Status",
      render: (_v, row) => {
        const isActive = getRowIsActive(row);
        return (
          <span
            className={`status-badge ${isActive ? "status-active" : "status-expired"}`}
          >
            {isActive ? "Active" : "Inactive"}
          </span>
        );
      },
    },
    {
      key: "actions",
      label: "Actions",
      render: (value, row) => (
        <ActionMenu 
          row={row}
          onView={handleView}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ),
    },
  ];

  return <Datatable data={data} columns={columns} />;
};

export default IndustryData;
